import { MapContainer, LayersControl } from 'react-leaflet';
import L, { Point, LatLng, Transformation } from 'leaflet';
import styled from 'styled-components/macro';
import { MapMods } from '../components/map/mapMods';
import { SDTDTileLayer } from '../components/map/tileLayer';
import { CoordinatesLayer } from '../components/map/coordinates';
import { GameTimeLayer } from '../components/map/gameTime';
import { AnimalLayer } from '../components/map/animals';
import { HostileLayer } from '../components/map/hostiles';
import { useEffect, useState } from 'react';
import { HTTP } from '../lib/http';
import { HideBasedOnAuth } from '../components/auth/hideBasedOnAuth';
import { PERMISSIONS } from '../components/auth';
import { PlayerLayer } from '../components/map/players';

const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export function Map() {
  const [mapConfig, setMapConfig] = useState({ enabled: false });

  const mapInfo = {
    regionSize: 512,
    chunkSize: 16,
    tileSize: 128,
    maxZoom: 4,
  };

  useEffect(() => {
    const fetchMapConfig = async () => {
      const response = await HTTP.getMapConfig();
      setMapConfig(response);
    };

    fetchMapConfig();
  }, []);

  const SDTD_Projection = {
    project: (latlng) => {
      return new Point(latlng.lat / Math.pow(2, mapInfo.maxZoom), latlng.lng / Math.pow(2, mapInfo.maxZoom));
    },

    unproject: (point) => {
      return new LatLng(point.x * Math.pow(2, mapInfo.maxZoom), point.y * Math.pow(2, mapInfo.maxZoom));
    },
  };

  const SDTD_CRS = L.extend({}, L.CRS.Simple, {
    projection: SDTD_Projection,
    transformation: new Transformation(1, 0, -1, 0),

    scale: function (zoom) {
      return Math.pow(2, zoom);
    },
  });

  if (!mapConfig.enabled) {
    return <p>Map is not enabled, you can enable it via the server settings config file.</p>;
  }

  return (
    <Container>
      <HideBasedOnAuth requiredPermission={{ module: PERMISSIONS['web.map'], method: 'GET' }}>
        <MapContainer
          style={{ width: '100%', height: '100%' }}
          center={[0, 0]}
          zoom={Math.max(0, mapInfo.maxZoom - 3)}
          scrollWheelZoom={false}
          attributionControl={false}
          crs={SDTD_CRS}
        >
          <SDTDTileLayer mapInfo={mapInfo}></SDTDTileLayer>
          <CoordinatesLayer />

          <HideBasedOnAuth requiredPermission={{ module: PERMISSIONS['webapi.ServerStats'], method: 'GET' }}>
            <GameTimeLayer />
          </HideBasedOnAuth>

          <LayersControl position="topright">
            <HideBasedOnAuth requiredPermission={{ module: PERMISSIONS['webapi.Player'], method: 'GET' }}>
              <LayersControl.Overlay name="Players">
                <PlayerLayer />
              </LayersControl.Overlay>
            </HideBasedOnAuth>

            <HideBasedOnAuth requiredPermission={{ module: PERMISSIONS['webapi.Animal'], method: 'GET' }}>
              <LayersControl.Overlay name="Animals">
                <AnimalLayer />
              </LayersControl.Overlay>
            </HideBasedOnAuth>

            <HideBasedOnAuth requiredPermission={{ module: PERMISSIONS['webapi.Hostile'], method: 'GET' }}>
              <LayersControl.Overlay name="Hostiles">
                <HostileLayer />
              </LayersControl.Overlay>
            </HideBasedOnAuth>

            <MapMods />
          </LayersControl>
        </MapContainer>
      </HideBasedOnAuth>
    </Container>
  );
}
